import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';
import { AccessibilityToolbarModule } from 'src/app/components/accessibility-toolbar/accessibility-toolbar.module';

@NgModule({
  declarations: [SidenavComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
      AccessibilityToolbarModule
  ],
  exports: [SidenavComponent],
})
export class SidenavModule { }
